import React, { memo } from 'react';
import { IconCalendar } from '@tabler/icons-react';
import './PeriodIndicator.css';
import { formatPeriod, getLastMonthOfYear } from '../Util/getAvailablePeriod';
import { useAvailablePeriod } from '../contexts/AvailablePeriodContext';

const formatRange = (start, end) =>
    `${formatPeriod(start)} a ${formatPeriod(end)}`;

export const getSelectedPeriodLabel = (filters, available) => {
    const year = filters?.year?.value || '';
    const month = filters?.month?.value || '';

    if (year && month) {
        return formatPeriod({ year, month });
    }

    // Ano inteiro: limitado pelos meses com dados daquele ano.
    if (year) {
        const startMonth = year === available.start.year ? available.start.month : '01';
        const endMonth =
            year === available.end.year
                ? available.end.month
                : getLastMonthOfYear(year);

        return formatRange({ year, month: startMonth }, { year, month: endMonth });
    }

    // Mesmo mês em todos os anos: o último ano só entra se o mês já ocorreu.
    if (month) {
        const endYear =
            Number(month) > Number(available.end.month)
                ? `${Number(available.end.year) - 1}`
                : available.end.year;

        return formatRange(
            { year: available.start.year, month },
            { year: endYear, month }
        );
    }

    return formatRange(available.start, available.end);
};

// `filters` é o estado de filtros do dashboard ({ year, month }), lido do
// contexto de cada dashboard e repassado por quem renderiza o indicador.
const PeriodIndicator = ({ filters, className = '' }) => {
    const { availablePeriod, hasData } = useAvailablePeriod();

    if (!hasData) {
        return (
            <div
                className={`period-indicator period-indicator--empty ${className}`}
            >
                <IconCalendar size={18} className="period-indicator__icon" />
                <span className="period-indicator__item">
                    Nenhum dado disponível para os filtros selecionados.
                </span>
            </div>
        );
    }

    return (
        <div className={`period-indicator ${className}`}>
            <IconCalendar size={18} className="period-indicator__icon" />
            <span className="period-indicator__item">
                Período selecionado:{' '}
                <strong>
                    {getSelectedPeriodLabel(filters, availablePeriod)}
                </strong>
            </span>
            <span className="period-indicator__divider" aria-hidden="true" />
            <span className="period-indicator__item period-indicator__item--muted">
                Dados disponíveis:{' '}
                <strong>
                    {formatRange(availablePeriod.start, availablePeriod.end)}
                </strong>
            </span>
        </div>
    );
};

export default memo(PeriodIndicator);
